var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegisteredProperty({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rent_-_Free_real_estate_icons-2",
    "data-name": "Rent - Free real estate icons-2",
    transform: "translate(-16 -16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline",
    transform: "translate(16 16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9885",
    "data-name": "Path 9885",
    d: "M75.333,26h5v6.667a5,5,0,1,0,10,0V29.333H87v3.333a1.667,1.667,0,1,1-3.333,0v-10a3.333,3.333,0,1,1,6.667,0H87V26h40V36a1.667,1.667,0,0,0,1.667,1.667h10v20H142V36a1.667,1.667,0,0,0-.488-1.179L129.845,23.155a1.667,1.667,0,0,0-1.179-.488h-35a6.667,6.667,0,0,0-13.333,0H73.667A1.667,1.667,0,0,0,72,24.333v40h3.333Zm55,2.357,5.976,5.976h-5.976Z",
    transform: "translate(-60.333 -16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9886",
    "data-name": "Path 9886",
    d: "M347.667,380H336v3.333h13.333A1.667,1.667,0,0,0,351,381.667V360h-3.333Z",
    transform: "translate(-268.587 -288.333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9887",
    "data-name": "Path 9887",
    d: "M161.667,384A1.667,1.667,0,0,0,160,385.667V394a1.667,1.667,0,0,0,1.667,1.667h10A1.667,1.667,0,0,0,173.333,394v-8.333A1.667,1.667,0,0,0,171.667,384ZM170,392.333h-6.667v-5H170Z",
    transform: "translate(-129.671 -307.333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9888",
    "data-name": "Path 9888",
    d: "M104,336h3.333v3.333H104Z",
    transform: "translate(-85.486 -269.333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9889",
    "data-name": "Path 9889",
    d: "M76,280c0-4.141-2.29-8.333-6.667-8.333s-6.667,4.192-6.667,8.333c0,.934-.36,1.336-1.174,2.156a6.014,6.014,0,0,0-2.16,4.559A6.226,6.226,0,0,0,60.255,290H42.667V268.333A1.667,1.667,0,0,0,41,266.667H31a1.667,1.667,0,0,0-1.667,1.667V290h-5V260.569l20-8.75,20,8.75V270h3.333v-7.973l2.665,1.167a1.667,1.667,0,0,0,2.335-1.527v-8.333a1.667,1.667,0,0,0-1-1.527L45,240.14a1.667,1.667,0,0,0-1.336,0L17,251.807a1.667,1.667,0,0,0-1,1.527v8.333a1.667,1.667,0,0,0,2.335,1.527L21,262.028V290H16v3.333H72.667a7.164,7.164,0,0,0,4.152-1.562,6.326,6.326,0,0,0,2.515-5.056,6.015,6.015,0,0,0-2.159-4.559C76.36,281.336,76,280.934,76,280ZM19.333,259.118v-4.7l25-10.937,25,10.938v4.7l-1.667-.729v-.056h-.127L45,248.473a1.667,1.667,0,0,0-1.336,0l-22.538,9.86H21v.056ZM32.667,270h6.667v20H32.667Zm40,20H66c-.918,0-3.333-1.01-3.333-3.285,0-.969.365-1.378,1.192-2.21A5.956,5.956,0,0,0,66,280c0-3.955,2.18-5,3.333-5,2.637,0,3.333,3.271,3.333,5a5.956,5.956,0,0,0,2.141,4.5c.826.833,1.192,1.241,1.192,2.21C76,288.99,73.583,290,72.667,290Z",
    transform: "translate(-16 -193.333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9890",
    "data-name": "Path 9890",
    d: "M344.27,178.7l3.939-5.825a5,5,0,1,0-8.284-5.6l-27.077,40.037a1.666,1.666,0,0,0-.271.716l-.974,7.39a1.667,1.667,0,0,0,2.47,1.67l6.5-3.655a1.664,1.664,0,0,0,.563-.519l21.213-31.366,2.294,2.558-6.74,9.967,2.761,1.867,7.47-11.045a1.667,1.667,0,0,0-.14-2.046Zm-1.583-9.56a1.667,1.667,0,1,1,2.761,1.867l-3.473,5.135-2.294-2.558ZM318.592,210.72l-3.248,1.827.487-3.695,4.448-6.577,2.761,1.867Zm6.315-9.338-2.761-1.867,15.61-23.083,2.294,2.559Z",
    transform: "translate(-249.068 -134.018)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9891",
    "data-name": "Path 9891",
    d: "M136,144h3.333v3.333H136Z",
    transform: "translate(-110.754 -117.333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9892",
    "data-name": "Path 9892",
    d: "M168,144h40v3.333H168Z",
    transform: "translate(-135.829 -117.333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9893",
    "data-name": "Path 9893",
    d: "M120,176h50v3.333H120Z",
    transform: "translate(-97.918 -142.667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9894",
    "data-name": "Path 9894",
    d: "M120,208h50v3.333H120Z",
    transform: "translate(-97.918 -168)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9895",
    "data-name": "Path 9895",
    d: "M240,240h25v3.333H240Z",
    transform: "translate(-192.74 -193.333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9896",
    "data-name": "Path 9896",
    d: "M304,272h5v3.333h-5Z",
    transform: "translate(-243.4 -218.667)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisteredProperty);
export default __webpack_public_path__ + "static/media/registeredProperty.7754592b631511f211baf28144d5d060.svg";
export { ForwardRef as ReactComponent };